
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import PrivacyPage from '../pages/privacy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
